import { NameIdentifiers, FormStepValue, FormStep } from "../types";

export const getStepValue = (
  steps: FormStep[],
  name: NameIdentifiers,
): FormStepValue | undefined => {
  const step = steps.find((step) => step.name === name);
  return step?.value;
};
